<template>
  <input
    class="input-field"
    :type="field.type"
    :value="value"
    v-bind="$attrs"
    v-on="listeners"
  >
</template>

<script>

export default {
  name: 'AppInputField',

  model: {
    prop: 'value',
  },

  props: {
    value: {
      type: String,
      default: '',
    },

    field: {
      type: Object,
      default() {
        return {
          type: 'text',
        };
      },
    },
  },

  computed: {
    listeners() {
      return {
        ...this.$listeners,
        input: event => this.$emit('input', event.target.value),
      };
    },
  },
};

</script>

<style lang="scss" scoped>
  .input-field {
    @apply px-2;
    @apply py-2;
    @apply w-full;
    @apply text-gray-800;
    @apply text-base;
    @apply font-semibold;
    @apply bg-gray-100;
    @apply border-2;
    @apply border-gray-200;
    @apply rounded;
    @apply appearance-none;

    &:focus {
      @apply outline-none;
      @apply bg-white;
      @apply border-pink-300;
    }

    &--has-error {
      @apply border-red-300;
      @apply bg-red-100;
    }

     @media(min-width: theme('screens.sm')) {
      @apply py-1;
    }

  }
</style>
